import { useState } from "react";

type Side = "left" | "right";
type Panels = Record<Side, boolean>;

/** Open/collapsed side panels: remembered, else collapsed below 1440 px wide. */
export function usePanels() {
  const [panels, setPanels] = useState<Panels>(() => {
    const saved = localStorage.getItem("coup:panels");
    if (saved) return JSON.parse(saved) as Panels;
    const wide = window.innerWidth >= 1440;
    return { left: wide, right: wide };
  });
  const toggle = (side: Side) => {
    const next = { ...panels, [side]: !panels[side] };
    localStorage.setItem("coup:panels", JSON.stringify(next));
    setPanels(next);
  };
  return { ...panels, toggle };
}
